<template>
 <div id="containerbar" >
        <!-- Start Container -->
        <div class="container">
            <div class="auth-box login-box">
                <!-- Start row -->
                <div class="row no-gutters align-items-center justify-content-center">
                    <!-- Start col -->
                    <div class="col-md-12 col-lg-12">
                        <!-- Start Auth Box -->
                        <div class="auth-box-right">
                            <div class="card">
                                <div class="card-body">

                                    <form  @submit.prevent="attemptLogin" action="#">
                                        <div class="form-head border-0" >
                                            <a href="/" class="logo"><img src="assets/images/logo.svg" class="img-fluid" alt="logo"></a>
                                        </div>                                        
                                       <div class="mb-3 mt-3" v-html="oblivioncontent">
                                           
                                       </div>
                                        <div class="form-group">
                                            <input type="text" class="form-control" id="username" placeholder="Inserisci il tuo indirizzo email" v-model="user.username" required="">
                                        </div>
                                       
                                        <b-row v-if="errormessage!=''">
                                        <b-col cols="12" class="text-center alert alert-danger">
                                            {{errormessage}}
                                        </b-col>

                                    </b-row>   
                                    <b-row v-if="successmessage!=''">
                                        <b-col cols="12" class="text-center alert alert-success">
                                            {{successmessage}}
                                        </b-col>

                                    </b-row>                      
                                      <button type="submit" v-if="!sending" class="btn btn-info btn-lg btn-block font-18 mb-3">Richiedi oblio</button>
                                     
                                    </form>
                                   
                                </div>
                            </div>
                        </div>
                        <!-- End Auth Box -->
                    </div>
                    <!-- End col -->
                </div>
                <!-- End row -->
            </div>
        </div>
        <!-- End Container -->
    </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'ViewOblivion',
  data() {
    return {
      user: {
        username: '',
        password: ''
      },
      oblivioncontent:'',
      errormessage: '',
      successmessage:'',
      sending: false
    };
  },
  mounted(){
 axios.get('messagetemplate/bycode/oblivion.content').then(response => {
this.oblivioncontent = response.data.data;

 });

  },
  methods: {
      attemptLogin() {
          var me = this;
     me.successmessage = me.errormessage = "";
         this.sending = true;
             axios.post('user/oblivion', {
                      username: me.user.username,
                      password:"xxxx"
                  }).then(response => {

                      if (response.status == 200 && !response.data.error) {
                          me.successmessage="Perfetto, la tua richiesta è stata accettata, controlla la tua mail"
                      }
                      else {
                          me.sending = false;
                          me.errormessage = 'Attenzione, non riconosco la tua mail';
                      }


                  }) 
                  .catch(error => {
                     me.sending = false;
                      me.errormessage = 'Attenzione, non riconosco la tua mail';
                  });


          
     
    }
  }
};
</script>
